<template>
    <div class='bottom-footer-container'>
    
        <div>© {{year}} itimAIQ. All Rights Reserved</div>
        <div class='end-section'>
            <div class='bottom-link' @click='onClickLink("privacy")'>Privacy</div>
            <div class='bottom-link' @click='onClickLink("terms")'>Terms</div>
            <div class='bottom-link' @click='onClickLink("cookies")'>Cookies</div>
        </div>
       
    </div>
</template>

<script>
export default {
    data(){
        return{
            year: new Date().getFullYear()
        }
    },
    methods:{
        onClickLink(page, external = false) {
            if(external) {
                window.open(page, '_blank');
            } else {
                this.$router.push(`/${page}`);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.bottom-footer-container{
    display: flex;
    justify-content: space-between;
    gap: 50px;
    font-size: 0.9rem;
    // color: var(--black);

    @media(max-width: 1500px){
        flex-wrap: wrap;
    }

    @media(max-width: 768px){
        // justify-content: center;
        gap: 20px;  
        // margin-left: 30px;
    }
}

.end-section{
    display: flex;
    gap: 30px;

    @media(max-width: 768px){
        margin-bottom: 40px;
        justify-content: center;
    }
}

.payment_option_card{
    background-color: white;
    width: 46px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    padding: 2px 6px;
}

.footer-payment-option-image{
    width: 35px;
    margin: auto;
}

.bottom-link{
    cursor: pointer;
    &:hover{
        text-decoration: underline;
    }
}

</style>